import { UserAvatar } from "common/elements";
import i18n from "features/parent/i18n";
import { AppUser } from "features/user/types";

interface ChildSelectorProps {
  childUsers: AppUser[];
  selectedUser: AppUser | undefined;
  activeUid: string | undefined;
  onSelectChild: (uid: string) => void;
  onAddChild: () => void;
}

export function ChildSelector({
  childUsers,
  selectedUser,
  activeUid,
  onSelectChild,
  onAddChild,
}: ChildSelectorProps) {
  return (
    <div className="flex-row-el gap-3 overflow-x-auto invisible-scrollbar pb-2">
      {childUsers.map((user) => (
        <button
          key={user.uid}
          className={`relative flex-col-el items-center gap-2 px-4 py-3 min-w-[100px] rounded-xl cursor-pointer transition-all ${
            selectedUser?.uid === user.uid
              ? "bg-blue-10 border-2 border-blue-100"
              : "bg-white border-2 border-transparent hover:bg-surface"
          }`}
          onClick={() => onSelectChild(user.uid)}
        >
          <UserAvatar size={48} icon={user.icon} />
          <span className="text-[21px] text-textcolor-black">{user.display_name}</span>
          {user.uid === activeUid && (
            <div className="absolute top-2 right-2 w-2 h-2 rounded-full bg-green-100" />
          )}
        </button>
      ))}
      <button
        className="flex-col-el items-center justify-center gap-2 px-4 py-3 min-w-[100px] rounded-xl border-2 border-dashed border-gray2-60 bg-transparent cursor-pointer hover:border-blue-100 hover:bg-blue-10 transition-all"
        onClick={onAddChild}
      >
        <span className="material-symbols-outlined text-2xl text-gray2-100">add</span>
        <span className="text-[21px] text-gray2-100">{i18n.t("MSG_PARENT_PAGE_ADD")}</span>
      </button>
    </div>
  );
}
